module.exports = __webpack_public_path__ + "img/ico_social_facebook.eee5a4a1.svg";